export default __webpack_public_path__ + "static/media/previewComplete.d604c8a6.mp3";